module.exports = __webpack_public_path__ + "static/media/shoppingBag.b925af2a.svg";